import toast from 'react-hot-toast'
import { useMutation, useQueryClient } from 'react-query'
import { store } from '..'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { handleErrors } from 'utils/handle-errors'
import { organizationsKeys, zakekeOrderLineQueryKeys } from 'utils/query-keys'
import { ID } from 'utils/types'
import { DirectoryMapping } from 'interfaces/directory-mapping'

const sendUpdateDirectoryMapping = async ({
  orgId,
  directoryMapping,
}: {
  orgId: ID
  directoryMapping: Partial<DirectoryMapping>
}) => {
  let response = await fetch(
    `${BASE_API_URL}/api/v3/organizations/${orgId}/directory_mappings/${directoryMapping.id}`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify(directoryMapping),
    }
  )
  response = handleErrors(response)
  const json = await response.json()
  return json.data.directory_mapping
}

const useUpdateDirectoryMapping = (orgId: ID) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ directoryMapping }: { directoryMapping: Partial<DirectoryMapping> }) => {
      return sendUpdateDirectoryMapping({ orgId, directoryMapping })
    },
    {
      onError: (e, variables, context) => {
        console.error(e)
        alert(
          'Uh oh! There was an error! Check the console. Take a screenshot and send to engineers.'
        )
      },
      onSuccess: (data, variables, context) => {
        toast('Directory Mapping is updated', { icon: `👍` })
        queryClient.invalidateQueries(
          organizationsKeys.directoryMappings.index(orgId)
        )
      },
    }
  )
}
export default useUpdateDirectoryMapping
